var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    style: {
      fill: "none",
      stroke: "#7cd959",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7cd959",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M16,5c-3.866,0-7,2.686-7,6v2h4v-2 c0-1.105,1.343-2,3-2s3,0.877,3,2c0,3.321-5,3.782-5,8h4c0-2.629,5-3.039,5-8C23,7.727,19.866,5,16,5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.4331f35135081da9f6980b17ad0783de.svg";
export { ForwardRef as ReactComponent };